export default "__VITE_PUBLIC_ASSET__aa379658__"